// extracted by mini-css-extract-plugin
export var baseButton = "_p9-0";
export var controlsArrowKeys = "_p9-1";
export var controlsResetButton = "_p9-2";
export var lightGameButton = "_p9-4 _p9-0";
export var playAgainButton = "_p9-5 _p9-0";
export var startGameButton = "_p9-3 _p9-0";